import { render, staticRenderFns } from "./QuizItem.vue?vue&type=template&id=776a67fe&scoped=true&"
import script from "./QuizItem.vue?vue&type=script&lang=js&"
export * from "./QuizItem.vue?vue&type=script&lang=js&"
import style0 from "./QuizItem.vue?vue&type=style&index=0&id=776a67fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "776a67fe",
  null
  
)

export default component.exports